// extracted by mini-css-extract-plugin
export default {"subtitle":"AssetsAssignConfigurationGroupForm_subtitle__bPrsj"};